<template>
    <div>
        <div class="col-12 px-0">
            <div class="d-flex align-items-center justify-content-between mb-0">
                <div>
                    <h5 class="font-weight-bold">
                        Motivos de finalização de {{ tipo }}
                    </h5>
                </div>

                <div>
                    <div class="input-group mb-3">
                        <b-input
                            v-model="search"
                            :placeholder="$t('Type to search')"
                            class="form-control search-input"
                            type="search"
                            aria-describedby="input-search-motivo"
                            @change="getListMotivos"
                        />

                        <div class="input-group-append" role="button">
                            <span
                                id="input-search-motivo"
                                class="input-group-text"
                            >
                                <i class="fas fa-search search-icon" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <form-input
                v-model="novoMotivo"
                label="Motivo"
                grid="5"
                placeholder="Descrição do motivo"
                :uppercase="false"
            />

            <div class="col-md-3">
                <div class="form-group">
                    <label>
                        Público-alvo
                        <span class="text-danger">*</span>
                    </label>

                    <select
                        v-model="publicoAlvo"
                        class="form-control"
                    >
                        <option :value="null" disabled>
                            Selecione
                        </option>

                        <option :value="1">
                            Criança e adolescente
                        </option>

                        <option :value="2">
                            Idoso
                        </option>

                        <option :value="3">
                            Adulto e família
                        </option>
                    </select>
                </div>
            </div>

            <form-input-color
                v-model="color"
                label="Cor"
                grid="2"
            />

            <div class="col-md-2 pl-0">
                <button
                    class="btn btn-block btn-success btn-sm mt-4"
                    :disabled="loading"
                    @click="inserirMotivo"
                >
                    Cadastrar
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />

                <b-alert
                    v-if="!statusFinalizadoId && !loading"
                    show
                    variant="warning"
                >
                    O status FINALIZADO do acolhimento não foi encontrado.
                </b-alert>

                <b-table
                    :fields="fields"
                    :items="MotivosList"
                    :responsive="true"
                    striped
                    hover
                    show-empty
                    small
                    outlined
                    stacked="md"
                    table-class="mb-3"
                >
                    <template v-slot:cell(id)="data">
                        {{ data.item.id }}
                    </template>

                    <template v-slot:cell(titulo)="data">
                        <strong>
                            {{ descricaoMotivo(data.item) }}
                        </strong>
                    </template>

                    <template v-slot:cell(publico_alvo)="data">
                        {{ descricaoPublicoAlvo(data.item.publico_alvo) }}
                    </template>

                    <template v-slot:cell(origem)="data">
                        {{ data.item.origem || "-" }}
                    </template>

                    <template v-slot:cell(cor)="data">
                        <div class="d-flex align-items-center">
                            <span
                                class="cor-status mr-2"
                                :style="{
                                    backgroundColor: data.item.cor || '#616161'
                                }"
                            />

                            {{ data.item.cor || "#616161" }}
                        </div>
                    </template>

                    <template v-slot:cell(actions)="data">
                        <b-button
                            v-if="podeExcluir(data.item)"
                            class="px-2 mb-0"
                            size="xs"
                            type="button"
                            variant="danger"
                            v-b-tooltip.hover
                            title="Excluir motivo"
                            @click="excluir(data.item)"
                        >
                            <i class="mdi mdi-delete" />
                        </b-button>
                    </template>

                    <template v-slot:empty>
                        <div class="text-center my-5">
                            <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                            />

                            <h3 class="bold">
                                {{ $t("No records found") }}
                            </h3>
                        </div>
                    </template>
                </b-table>

                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group d-inline-flex mb-0">
                            <select
                                v-model="perPage"
                                class="form-control"
                                style="width: 70px"
                                @change="alterarQuantidadePorPagina"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </select>
                        </div>

                        <div class="d-inline-flex ml-2">
                            <b-pagination
                                v-model="page"
                                :per-page="Number(perPage)"
                                :total-rows="pagination.total"
                                @change="changePage"
                            />
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                        <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                        </div>
                    </div>
                </div>
            </div>

            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    name: "MotivosAcolhimento",

    props: ["tipo", "modulo", "model"],

    data() {
        return {
            MotivosList: [],
            novoMotivo: "",
            publicoAlvo: null,
            color: "#616161",
            statusFinalizadoId: null,
            page: 1,
            search: "",
            perPage: 10,
            loading: false,

            fields: [
                {
                    key: "id",
                    label: this.$t("ID"),
                },
                {
                    key: "titulo",
                    label: "Motivo",
                },
                {
                    key: "publico_alvo",
                    label: "Público-alvo",
                },
                {
                    key: "origem",
                    label: this.$t("Origem"),
                },
                {
                    key: "cor",
                    label: "Cor",
                },
                {
                    key: "actions",
                    label: "",
                    class: "text-right",
                    thStyle: {
                        width: "60px",
                        minWidth: "60px",
                    },
                },
            ],

            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
        };
    },

    watch: {
        tipo() {
            this.carregar();
        },
    },

    mounted() {
        this.carregar();
    },

    methods: {
        async carregar() {
            this.loading = true;
            this.statusFinalizadoId = null;
            this.MotivosList = [];

            try {
                await this.buscarStatusFinalizado();

                if (this.statusFinalizadoId) {
                    await this.getListMotivos();
                }
            } catch (error) {
                this.mostrarErro(
                    error,
                    "Não foi possível carregar os motivos de finalização."
                );
            } finally {
                this.loading = false;
            }
        },

        async buscarStatusFinalizado() {
            const response = await axios.post(
                "api/dashboard/admin/getStatus",
                {
                    model: this.model || this.modulo,
                    module: this.modulo,
                }
            );

            const status = response.data.data || [];

            const finalizado = status.find((item) => {
                const descricao = String(
                    item.descricao || item.titulo || ""
                )
                    .trim()
                    .toUpperCase();

                return descricao === "FINALIZADO";
            });

            this.statusFinalizadoId = finalizado
                ? finalizado.id
                : null;
        },

        async getListMotivos() {
            if (!this.statusFinalizadoId) {
                return;
            }

            this.loading = true;

            try {
                const response = await axios.post(
                    "api/dashboard/admin/list/status",
                    {
                        model: this.model || this.modulo,
                        module: this.modulo,
                        status_pai: this.statusFinalizadoId,
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                    }
                );

                this.MotivosList = response.data.data || [];
                this.pagination = response.data.pagination;

                if (
                    this.pagination.totalPages > 0 &&
                    this.pagination.currentPage >
                        this.pagination.totalPages
                ) {
                    this.page = this.pagination.totalPages;
                    await this.getListMotivos();
                }
            } catch (error) {
                this.mostrarErro(
                    error,
                    "Não foi possível listar os motivos."
                );
            } finally {
                this.loading = false;
            }
        },

        async inserirMotivo() {
            const descricao = String(this.novoMotivo || "").trim();

            if (!descricao) {
                this.$snack.error({
                    button: false,
                    text: "Informe a descrição do motivo.",
                });

                return;
            }

            if (!this.publicoAlvo) {
                this.$snack.error({
                    button: false,
                    text: "Selecione o público-alvo.",
                });

                return;
            }

            if (!this.statusFinalizadoId) {
                this.$snack.error({
                    button: false,
                    text: "O status FINALIZADO não foi encontrado.",
                });

                return;
            }

            this.loading = true;

            try {
                await axios.post(
                    "api/dashboard/admin/status",
                    {
                        descricao,
                        cor: this.color || "#616161",
                        final: 1,
                        status_pai: this.statusFinalizadoId,
                        publico_alvo: Number(this.publicoAlvo),

                        /*
                         * Os motivos criados pela seeder são SISTEMA.
                         * Os cadastrados pelo município serão MUNICIPIO.
                         */
                        origem: "MUNICIPIO",

                        model: this.model || this.modulo,
                        module: this.modulo,
                    }
                );

                this.$snack.success({
                    button: false,
                    text: "Motivo cadastrado com sucesso.",
                });

                this.novoMotivo = "";
                this.publicoAlvo = null;
                this.color = "#616161";
                this.page = 1;

                await this.getListMotivos();
            } catch (error) {
                this.mostrarErro(
                    error,
                    "Não foi possível cadastrar o motivo."
                );
            } finally {
                this.loading = false;
            }
        },

        async excluir(item) {
            try {
                await axios.get(
                    `api/dashboard/admin/excluir/status/${item.id}/${this.modulo}`
                );

                this.$snack.success({
                    button: false,
                    text: "Motivo excluído com sucesso.",
                });

                await this.getListMotivos();
            } catch (error) {
                this.mostrarErro(
                    error,
                    "Não foi possível excluir o motivo."
                );
            }
        },

        podeExcluir(item) {
            return (
                String(item.origem || "")
                    .trim()
                    .toUpperCase() !== "SISTEMA"
            );
        },

        descricaoMotivo(item) {
            return item.descricao || item.titulo || "-";
        },

        descricaoPublicoAlvo(publicoAlvo) {
            const publicos = {
                1: "Criança e adolescente",
                2: "Idoso",
                3: "Adulto e família",
            };

            return publicos[Number(publicoAlvo)] || "-";
        },

        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getListMotivos();
            }
        },

        alterarQuantidadePorPagina() {
            this.page = 1;
            this.getListMotivos();
        },

        mostrarErro(error, mensagemPadrao) {
            const mensagem =
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : mensagemPadrao;

            this.$snack.error({
                button: false,
                text: mensagem,
            });
        },
    },
};
</script>

<style scoped>
.cor-status {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}
</style>